import { RoleRegisterMessages, TranslationRoleRegisterMessages } from "../interfaces/roleRegisterMessages";

export const messages: TranslationRoleRegisterMessages = {
  [RoleRegisterMessages.titleCreate]: "Create group",
  [RoleRegisterMessages.titleEdit]: "Edit group",
  [RoleRegisterMessages.stepTabFormRole]: "Group data",
  [RoleRegisterMessages.stepTabAddUsers]: "Add users",
  [RoleRegisterMessages.noUsersRegistered]: "There are no registered users",
  [RoleRegisterMessages.userIsAMemberOfAnotherRole]: "The selected user already belongs to another group."
  + " By confirming, he will belong to this group."
};